import { axiosClient } from '@lib/axiosClient';

export interface SignatureCoordinates {
  x: number;
  y: number;
}

export interface RequestSignaturePayload {
  fileId: string;
  userCpf: string;
  coordinates: SignatureCoordinates;
}

export async function uploadFile(file: File, accessToken: string): Promise<{ fileId: string }> {
  const formData = new FormData();
  formData.append('file', file);

  const { data } = await axiosClient.post('/api/backend/v1/signature/file', formData, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });

  return data;
}

export async function requestSignature(
  payload: RequestSignaturePayload,
  accessToken: string,
): Promise<{ orderId: string }> {
  const { data } = await axiosClient.post(
    '/api/backend/v1/signature/request/internal',
    {
      userId: payload.userCpf,
      description: 'Solicitação de assinatura via aplicação',
      coordinates: payload.coordinates,
      metadata: { env: 'development' },
      fileId: payload.fileId,
      detached: true,
    },
    { headers: { Authorization: `Bearer ${accessToken}` } },
  );

  return data;
}

export async function checkSignatureStatus(orderId: string, accessToken: string): Promise<{ status: string }> {
  const { data } = await axiosClient.get(`/api/backend/v1/signature/${orderId}`, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });

  return data;
}

export async function downloadSignedFile(fileId: string, accessToken: string): Promise<Blob> {
  const { data } = await axiosClient.get(`/api/backend/v1/signature/file/${fileId}`, {
    headers: { Authorization: `Bearer ${accessToken}` },
    responseType: 'blob',
  });

  return data;
}
